import vbDenChoXuLyIndex from "../views/doc-in/vbDenChoXuLyIndex.vue";
import vbDenToTrinhQuaHanIndex from "../views/doc-in/to-trinh-qua-han/vb-den-to-trinh-qua-han-index.vue";
import vbDenTuTrucLienThongIndex from "../views/doc-in/tu-truc-lien-thong/vb-den-tu-truc-lien-thong-index";
import vbDenDaXuLyIndex from "../views/doc-in/vbDenDaXuLyIndex.vue";
import vbDenThuHoiIndex from "../views/doc-in/vbDenThuHoiIndex.vue";
import vbDenDaXuLyVTIndex from "../views/doc-in/vbDenDaXuLyVTIndex.vue";
import vbDenDaTiepNhanIndex from "../views/doc-in/vbDenDaTiepNhanIndex.vue";
import Index from "../views/doc-in/Index.vue";
import VbDaVaoSoIndex from "../views/doc-in/vbDaVaoSoIndex.vue";
import VbDenDaVaoSoLDIndex from "../views/doc-in/vbDenDaVaoSoLDIndex.vue";
import Detail from "../views/doc-in/Detail.vue";
import Create from "../views/doc-in/Create.vue";
import vbDenUyQuyenIndex from "../views/doc-in/vbDenUyQuyenIndex";
import tdhvpDocInIndex from "../views/thdvp/doc-in/tdhvp-doc-in-index";
import tdhvpDocInDetail from "../views/thdvp/doc-in/tdhvp-doc-in-detail";
import tdhvpDocInVtIndex from "../views/thdvp/doc-in/tdhvp-doc-in-vt-index";
import vbDaVaoSoLDDetail from "../views/doc-in/vbDaVaoSoLDDetail";
import vbDenDaVaoSoLDIndex from "../views/doc-in/vbDenDaVaoSoLDIndex";
import vbDenTuTrucLienThongDetail from "../views/doc-in/tu-truc-lien-thong/vb-den-tu-truc-lien-thong-detail";
import lockedRoleDocInIndex from "../views/doc-in/locked-role/lockedRoleDocInIndex.vue";
import lockedRoleDocInCV from "../views/doc-in/locked-role/lockedRoleDocInCV.vue";
import lockedRoleDocInVT from "../views/doc-in/locked-role/lockedRoleDocInVT.vue";
import DetailLockedRoleDocIn from "../views/doc-in/locked-role/Detail.vue";
import improperAccessCheckingService from "../services/improperAccessCheckingService";
import Constants from "../constants";

export default [
  {
    path: "/app/:userDeptRoleId/vbDaVaoSo",
    name: "vbDaVaoSo",
    component: VbDaVaoSoIndex,
    async beforeEnter(to, from, next) {
      await improperAccessCheckingService.isProperAccess(to, next, Constants.MENU_LIST.QL_SOVANBAN_SODEN)
    }
  },
  {
    path: "/app/:userDeptRoleId/vbDenDaVaoSoLD",
    name: "vbDenDaVaoSoLD",
    component: VbDenDaVaoSoLDIndex,
    async beforeEnter(to, from, next) {
      await improperAccessCheckingService.isProperAccess(to, next, Constants.MENU_LIST.DANHSACH_VANBAN_DEN)
    }
  },
  {
    path: "/app/:userDeptRoleId/vbDaVaoSo/detail/:id",
    name: "vbDaVaoSoDetail",
    components: {
      default: VbDaVaoSoIndex,
      detail: Detail
    },
    async beforeEnter(to, from, next) {
      await improperAccessCheckingService.isProperAccess(to, next, Constants.MENU_LIST.QL_SOVANBAN_SODEN)
    }
  },
  {
    path: "/app/:userDeptRoleId/vbDenDaVaoSoLD/detail/:id",
    name: "vbDenDaVaoSoLDDetail",
    components: {
      default: vbDenDaVaoSoLDIndex,
      detail: vbDaVaoSoLDDetail
    },
    async beforeEnter(to, from, next) {
      await improperAccessCheckingService.isProperAccess(to, next, Constants.MENU_LIST.DANHSACH_VANBAN_DEN)
    }
  },
  {
    path: "/app/:userDeptRoleId/vbChoTiepNhan",
    name: "vbChoTiepNhan",
    component: Index,
    async beforeEnter(to, from, next) {
      await improperAccessCheckingService.isProperAccess(to, next, Constants.MENU_LIST.VB_DEN_CHOTIEPNHAN)
    }
  },

  {
    path: "/app/:userDeptRoleId/vbChoTiepNhan/edit/:id",
    name: "vbChoTiepNhanEdit",
    components: {
      default: Index,
      detail: Create
    },
    async beforeEnter(to, from, next) {
      await improperAccessCheckingService.isProperAccess(to, next, Constants.MENU_LIST.VB_DEN_CHOTIEPNHAN)
    }
  },
  {
    path: "/app/:userDeptRoleId/vbChoTiepNhan/create",
    name: "vbChoTiepNhanCreate",
    components: {
      default: Index,
      detail: Create
    },
    async beforeEnter(to, from, next) {
      await improperAccessCheckingService.isProperAccess(to, next, Constants.MENU_LIST.VB_DEN_CHOTIEPNHAN)
    }
  },
  {
    path: "/app/:userDeptRoleId/vbChoTiepNhan/detail/:id",
    name: "vbChoTiepNhanDetailEditable",
    components: {
      default: Index,
      detail: () => import("../views/doc-in/detailEditable")
    },
    async beforeEnter(to, from, next) {
      await improperAccessCheckingService.isProperAccess(to, next, Constants.MENU_LIST.VB_DEN_CHOTIEPNHAN)
    }
  },
  {
    path: "/app/:userDeptRoleId/vbDenChoXuLy",
    name: "vbDenChoXuLy",
    component: vbDenChoXuLyIndex,
    async beforeEnter(to, from, next) {
      await improperAccessCheckingService.isProperAccess(to, next, Constants.MENU_LIST.VB_DEN_CHOXULY)
    }
  },
  {
    path: "/app/:userDeptRoleId/vbDenChoXuLy/detail/:id",
    name: "vbDenChoXuLyDetail",
    components: {
      default: vbDenChoXuLyIndex,
      detail: Detail
    },
    async beforeEnter(to, from, next) {
      await improperAccessCheckingService.isProperAccess(to, next, Constants.MENU_LIST.VB_DEN_CHOXULY)
    }
  },
  {
    path: "/app/:userDeptRoleId/vbDenUyQuyen",
    name: "vbDenUyQuyen",
    component: vbDenUyQuyenIndex,
    async beforeEnter(to, from, next) {
      await improperAccessCheckingService.isProperAccess(to, next, Constants.MENU_LIST.VB_DEN_UYQUYEN)
    }
  },
  {
    path: "/app/:userDeptRoleId/vbDenUyQuyen/detail/:id",
    name: "vbDenUyQuyenDetail",
    components: {
      default: vbDenUyQuyenIndex,
      detail: Detail
    },
    async beforeEnter(to, from, next) {
      await improperAccessCheckingService.isProperAccess(to, next, Constants.MENU_LIST.VB_DEN_UYQUYEN)
    }
  },
  {
    path: "/app/:userDeptRoleId/vbDenDaXuLy",
    name: "vbDenDaXuLy",
    component: vbDenDaXuLyIndex,
    async beforeEnter(to, from, next) {
      await improperAccessCheckingService.isProperAccess(to, next, Constants.MENU_LIST.VB_DEN_DAXULY)
    }
  },
  {
    path: "/app/:userDeptRoleId/vbDenDaXuLy/detail/:id",
    name: "vbDenDaXuLyDetail",
    components: {
      default: vbDenDaXuLyIndex,
      detail: Detail
    },
    async beforeEnter(to, from, next) {
      await improperAccessCheckingService.isProperAccess(to, next, Constants.MENU_LIST.VB_DEN_DAXULY)
    }
  },
  {
    path: "/app/:userDeptRoleId/vbDenDaTiepNhan",
    name: "vbDenDaTiepNhan",
    component: vbDenDaTiepNhanIndex,
    async beforeEnter(to, from, next) {
      await improperAccessCheckingService.isProperAccess(to, next, Constants.MENU_LIST.VB_DEN_DATIEPNHAN)
    }
  },
  {
    path: "/app/:userDeptRoleId/vbDenDaTiepNhan/detail/:id",
    name: "vbDenDaTiepNhanDetail",
    components: {
      default: vbDenDaTiepNhanIndex,
      detail: Detail
    },
    async beforeEnter(to, from, next) {
      await improperAccessCheckingService.isProperAccess(to, next, Constants.MENU_LIST.VB_DEN_DATIEPNHAN)
    }
  },

  {
    path: "/app/:userDeptRoleId/vbDenDaXuLyVT",
    name: "vbDenDaXuLyVT",
    component: vbDenDaXuLyVTIndex,
    async beforeEnter(to, from, next) {
      await improperAccessCheckingService.isProperAccess(to, next, Constants.MENU_LIST.VB_DEN_DAXULY_VT)
    }
  },
  {
    path: "/app/:userDeptRoleId/vbDenDaXuLyVT/detail/:id",
    name: "vbDenDaXuLyVTDetail",
    components: {
      default: vbDenDaXuLyVTIndex,
      detail: Detail
    },
    async beforeEnter(to, from, next) {
      await improperAccessCheckingService.isProperAccess(to, next, Constants.MENU_LIST.VB_DEN_DAXULY_VT)
    }
  },

  {
    path: "/app/:userDeptRoleId/vbDenThuHoi",
    name: "vbDenThuHoi",
    component: vbDenThuHoiIndex,
    async beforeEnter(to, from, next) {
      await improperAccessCheckingService.isProperAccess(to, next, Constants.MENU_LIST.VB_DEN)
    }
  },
  {
    path: "/app/:userDeptRoleId/vbDenThuHoi/detail/:id",
    name: "vbDenThuHoiDetail",
    components: {
      default: vbDenThuHoiIndex,
      detail: Detail
    },
    async beforeEnter(to, from, next) {
      await improperAccessCheckingService.isProperAccess(to, next, Constants.MENU_LIST.VB_DEN)
    }
  },
  {
    path: "/app/:userDeptRoleId/toTrinhQuaHan",
    name: "toTrinhQuaHan",
    component: vbDenToTrinhQuaHanIndex,
    async beforeEnter(to, from, next) {
      await improperAccessCheckingService.isProperAccess(to, next, Constants.MENU_LIST.VB_DEN_TO_TRINH_QUA_HAN)
    }
  },
  {
    path: "/app/:userDeptRoleId/toTrinhQuaHan/detail/:id",
    name: "toTrinhQuaHanDetail",
    components: {
      default: vbDenToTrinhQuaHanIndex,
      detail: Detail
    },
    async beforeEnter(to, from, next) {
      await improperAccessCheckingService.isProperAccess(to, next, Constants.MENU_LIST.VB_DEN_TO_TRINH_QUA_HAN)
    }
  },
  {
    path: "/app/:userDeptRoleId/tuTrucLienThong",
    name: "tuTrucLienThong",
    component: vbDenTuTrucLienThongIndex,
    async beforeEnter(to, from, next) {
      await improperAccessCheckingService.isProperAccess(to, next, Constants.MENU_LIST.VB_DEN_TU_TRUC_LIEN_THONG)
    }
  },
  {
    path: "/app/:userDeptRoleId/tuTrucLienThong/vbDenTuTrucLienThongDetail/:id",
    name: "tuTrucLienThongDetail",
    components: {
      default: vbDenTuTrucLienThongIndex,
      detail: vbDenTuTrucLienThongDetail
    },
    async beforeEnter(to, from, next) {
      await improperAccessCheckingService.isProperAccess(to, next, Constants.MENU_LIST.VB_DEN_TU_TRUC_LIEN_THONG)
    }
  },
  //chức năng tra cứu văn bản cũ từ hệ thống tdhvp
  {
    path: "/app/:userDeptRoleId/tdhvp-doc-in",
    name: "tdhvpDocInIndex",
    component: tdhvpDocInIndex,
    async beforeEnter(to, from, next) {
      await improperAccessCheckingService.isProperAccess(to, next, Constants.MENU_LIST.VB_DEN)
    }
  },
  {
    path: "/app/:userDeptRoleId/tdhvp-doc-in/detail/:id",
    name: "tdhvpDocInDetail",
    components: {
      default: tdhvpDocInIndex,
      detail: tdhvpDocInDetail
    },
    async beforeEnter(to, from, next) {
      await improperAccessCheckingService.isProperAccess(to, next, Constants.MENU_LIST.VB_DEN)
    }
  },
  {
    path: "/app/:userDeptRoleId/tdhvp-doc-in-vt",
    name: "tdhvpDocInVtIndex",
    component: tdhvpDocInVtIndex,
    async beforeEnter(to, from, next) {
      await improperAccessCheckingService.isProperAccess(to, next, Constants.MENU_LIST.VB_DEN)
    }
  },
  {
    path: "/app/:userDeptRoleId/tdhvp-doc-in-vt/detail/:id",
    name: "tdhvpDocInVtDetail",
    components: {
      default: tdhvpDocInVtIndex,
      detail: tdhvpDocInDetail
    },
    async beforeEnter(to, from, next) {
      await improperAccessCheckingService.isProperAccess(to, next, Constants.MENU_LIST.VB_DEN)
    }
  },
  //chức năng tra cứu văn bản cũ từ hệ thống tdhvp:end;
  //locked Role's Documents
  {
    path: "/app/:userDeptRoleId/lockedRoleDocInIndex",
    name: "lockedRoleDocInIndex",
    component: lockedRoleDocInIndex
  },
  {
    path: "/app/:userDeptRoleId/lockedRoleDocInCV",
    name: "lockedRoleDocInCV",
    component: lockedRoleDocInCV
  },
  {
    path: "/app/:userDeptRoleId/lockedRoleDocInVT",
    name: "lockedRoleDocInVT",
    component: lockedRoleDocInVT
  },
  {
    path: "/app/:userDeptRoleId/lockedRoleDocInCV/detail/:id",
    name: "DetailLockedRoleDocIn",
    components: {
      default: lockedRoleDocInCV,
      detail: DetailLockedRoleDocIn
    }
  },
  {
    path: "/app/:userDeptRoleId/lockedRoleDocInVT/detail/:id",
    name: "DetailLockedRoleDocInVT",
    components: {
      default: lockedRoleDocInVT,
      detail: DetailLockedRoleDocIn
    }
  },
  /////////////////////
];



// WEBPACK FOOTER //
// ./src/router/document-in.js